import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WeddingHome from "@/pages/WeddingHome";
import AdminPage from "@/pages/AdminPage";
import AccommodationPage from "@/pages/AccommodationPage";
import RSVPPage from "@/pages/RSVPPage";
import GuestGate from "@/components/wedding/GuestGate";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GuestGate>
          <Routes>
            <Route path="/" element={<WeddingHome />} />
            <Route path="/accommodation" element={<AccommodationPage />} />
            <Route path="/rsvp" element={<RSVPPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </GuestGate>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FAF9F6",
            color: "#1A1818",
            border: "1px solid rgba(106, 30, 45, 0.2)",
            fontFamily: "'Outfit', sans-serif",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
